<template>
  <div class="new-show">
    <div class="header"></div>
    <div class="news">
      <h1 class="title">{{ news.title }}</h1>
      <span>{{ timeChange(news.create_time || news.createTime) }}</span>
      <div
        style="margin-top: 20px; width: 1000px; margin: auto"
        v-html="news.content"
      ></div>
      <el-button type="primary" @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { myMixin } from '../../mixin'

export default {
  name: 'NewShow',
  mixins: [myMixin],
  data() {
    return {
      news: this.$store.state.news
    }
  },
  created() {
    window.scroll(0, 0);
  },
  methods: {
    ...mapMutations(['setNewEmpty']),
    back() {
      history.go(-1)
    }
  },
  destroyed() {
    this.setNewEmpty()
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 100px;
  background-color: rgb(0, 113, 193);
}

.new-show {
  min-height: 500px;
  line-height: 50px;
  margin: auto;
}

.title {
  width: 100%;
  font-weight: 400;
}

.news {
  width: 1180px;
  margin: 50px auto;
  text-align: center;
}
</style>
